/**
 * Work Management Service
 * Work tracking and management service API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WorkItemRelationshipDto { 
    /**
     * Target work item or resource ID
     */
    targetId: string;
    /**
     * Target entity type (e.g., WorkItem, CarePlan, Order, Task)
     */
    targetEntity: string;
    /**
     * Type of relationship
     */
    relationshipType: WorkItemRelationshipDto.RelationshipTypeEnum;
}
export namespace WorkItemRelationshipDto {
    export type RelationshipTypeEnum = 'relatedTo' | 'blocks' | 'blockedBy' | 'duplicates' | 'partOf' | 'basedOn';
    export const RelationshipTypeEnum = {
        RelatedTo: 'relatedTo' as RelationshipTypeEnum,
        Blocks: 'blocks' as RelationshipTypeEnum,
        BlockedBy: 'blockedBy' as RelationshipTypeEnum,
        Duplicates: 'duplicates' as RelationshipTypeEnum,
        PartOf: 'partOf' as RelationshipTypeEnum,
        BasedOn: 'basedOn' as RelationshipTypeEnum
    };
}


